// Variables de entorno de la aplicación

export const {
    PORT,
    REACT_APP_NAME_APP,
    REACT_APP_ID_SERVICE,
    REACT_APP_ID_TEMPLATE,
    REACT_APP_ID_USER
} = process.env;

// Ruta pública de assets según el basename de la app
export const getPublicPath = (): string => {
    if (REACT_APP_NAME_APP) {
        return REACT_APP_NAME_APP;
    }
    return '';
};
